const getActiveCampaignBanner = (banner, { storeCode  })=>{
    if (!banner) {
        return;
    }
    if (!(banner === null || banner === void 0 ? void 0 : banner.startDate) || !(banner === null || banner === void 0 ? void 0 : banner.endDate)) {
        return;
    }
    if (!(Date.now() > banner.startDate && Date.now() < banner.endDate)) {
        return;
    }
    // if there is no store specified we need to show the banner on all stores
    if (!banner.storesList) {
        return {
            url: banner.url,
            description: banner.description
        };
    }
    const list = banner.storesList.split(',');
    const storeNumberList = list.map((item)=>{
        const res = Number(item);
        if (isNaN(res)) {
            return;
        }
        return res;
    });
    const found = storeNumberList === null || storeNumberList === void 0 ? void 0 : storeNumberList.find((item)=>item === storeCode
    );
    if (found !== storeCode) {
        return;
    }
    return {
        url: banner.url,
        description: banner.description
    };
};

export { getActiveCampaignBanner };
//# sourceMappingURL=get-active-campaign-banner.js.map
